import Client from './client';

export default class ErpPriorityFiles extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/billing/erp/priority/files`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/billing/erp/priority/files`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/billing/erp/priority/files/${id}`, options);
  }

  deleteById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/billing/erp/priority/files/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
